const GroupType = {
    USER_GROUP: 'USER_GROUP',
    TIME_ZONE_GROUP: 'TIME_ZONE_GROUP'
};

export default GroupType;


// WEBPACK FOOTER //
// ./web/js/enums/GroupType.js